import React from 'react';

import LoadingScreen from '../LoadingScreen';
import { NotRegisteredUser } from '../NotRegisteredUser/NotRegisteredUser';

import { useOAuthServer } from './hooks/useOAuthServer';

export const OAuthCallback: React.FC = () => {
  const { isNotRegisteredUser } = useOAuthServer();

  if (isNotRegisteredUser) {
    return <NotRegisteredUser />;
  }

  return <LoadingScreen notifications={[]} />;
};
